import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Cinzel, Geist_Mono, Great_Vibes, Jost } from 'next/font/google'
import { ChatWidget } from '@/components/generals/chat-widget'
import { MobileActionBar } from '@/components/generals/mobile-action-bar'

const sans = Jost({
    subsets: ['latin']
})

const heading = Cinzel({
    subsets: ['latin']
})

const script = Great_Vibes({
    subsets: ['latin'],
    weight: '400'
})

const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-script:${script.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />

            <MobileActionBar />
            <ChatWidget />
        </div>
    )
}

export default App
